
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.974 40.747c-.36 0-.694-.147-.947-.387L12.533 23.867c-.52-.52-.52-1.36 0-1.88.52-.52 1.36-.52 1.88 0l15.56 15.56 15.6-15.6c.52-.52 1.36-.52 1.88 0 .52.52.52 1.36 0 1.88L30.92 40.36a1.32 1.32 0 01-.947.387z"}}),_c('path',{attrs:{"d":"M30 60C13.453 60 0 46.547 0 30S13.453 0 30 0s30 13.453 30 30-13.453 30-30 30zm0-57.333C14.933 2.667 2.667 14.933 2.667 30c0 15.067 12.266 27.333 27.333 27.333 15.067 0 27.333-12.266 27.333-27.333C57.333 14.933 45.067 2.667 30 2.667z"}})])
          )
        }
      }
    